import api from "./api";
import types from "./types";
import { request } from "api/apiSaga";
import { snackbarShow } from "app/App/actions";
import trans from "helpers/trans";
import { call, put, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";
import { appSettings as appSettingsRequest,} from "app/App/actions"
import { appSettings } from "app/App/saga";
function* destroy(action: AnyAction): any {
    const response = yield call(request, api.destroy, action, "delete");

    if (response.status === 204) {
        yield call(appSettings, appSettingsRequest());
        yield put(
            snackbarShow({
                content: trans("event.languages.saga.content.destroy"),
            })
        );
    }
}

function* fetch(action: AnyAction) {
    yield call(request, api.fetch, action);
}

function* fetchAll(action: AnyAction) {
    yield call(request, api.fetchAll, action);
}

function* fetchDefault(action: AnyAction) {
    yield call(request, api.fetchDefault, action);
}

function* get(action: AnyAction) {
    yield call(request, api.get, action);
}

function* patch(action: AnyAction): any {
    const response = yield call(request, api.patch, action, "patch");
    if (response.status === 200) {
        yield call(appSettings, appSettingsRequest());
        yield put(
            snackbarShow({
                content: trans("event.languages.saga.content.update"),
            })
        );
    }
}

function* store(action: AnyAction): any {
    const response = yield call(request, api.store, action, "post");

    if (response.status === 201) {
        yield call(appSettings, appSettingsRequest());
        yield put(
            snackbarShow({
                content: trans("event.languages.saga.content.store"),
            })
        );
    }
}

function* update(action: AnyAction): any {
    const response = yield call(request, api.update, action, "put");

    if (response.status === 200) {
        yield call(appSettings, appSettingsRequest());
        yield put(
            snackbarShow({
                content: trans("event.languages.saga.content.update"),
            })
        );
    }
}

export default function* saga() {
    yield takeLatest(types.DESTROY_REQUEST, destroy);
    yield takeLatest(types.FETCH_REQUEST, fetch);
    yield takeLatest(types.FETCH_ALL_REQUEST, fetchAll);
    yield takeLatest(types.FETCH_DEFAULT_REQUEST, fetchDefault);
    yield takeLatest(types.GET_REQUEST, get);
    yield takeLatest(types.PATCH_REQUEST, patch);
    yield takeLatest(types.STORE_REQUEST, store);
    yield takeLatest(types.UPDATE_REQUEST, update);
}
